import { AbstractControl, AsyncValidatorFn, ValidationErrors, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { ErzeugungsanlageService } from '../../../service/erzeugungsanlage/erzeugungsanlage.service';
import { catchError, map } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AnlagenschluesselValidator {

    public static readonly MAX_LENGTH = 33;
    public static readonly EEG_PATTERN = new RegExp('^E[1-4][0-9a-zA-Z!#\$%&\'()*+\\\\,\\-./:<=>?\\[\\]@^_`{}~]{31}$');

    private erzeugungsanlageService = inject(ErzeugungsanlageService);

    validate(dokumentenId?: string): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {
            if (!control.value) {
                return of(null);
            }

            const maxLength = Validators.maxLength(AnlagenschluesselValidator.MAX_LENGTH)(control);
            if (maxLength !== null) {
                return of(maxLength);
            }

            const pattern = Validators.pattern(AnlagenschluesselValidator.EEG_PATTERN)(control);
            if (pattern !== null) {
                return of(pattern);
            }

            return this.erzeugungsanlageService.isAnlagenschluesselUnique(control.value, dokumentenId)
                .pipe(
                    map(isUnique => isUnique ? null : { anlagenschluessel: true }),
                    catchError(() => {
                        console.error('Error while checking if anlagenschluessel is unique');
                        return of({ anlagenschluessel: true });
                    }),
                );
        };
    }
}
